import { LS2PAC_CONSTANTS } from "../../main/constants";
import { AccountHolder } from "../components/Account";
import { BranchLimitsHolder } from "../components/BranchLimits";
import { ListService } from "../components/pages/account/ListService";
import { TLCEvents } from "../events/events";

export function clearAccountData() {
  AccountHolder.clearAccountData();
  ListService.clearListData();
}
export function clearSearchHistory() {
  BranchLimitsHolder.setSelectedBranchLimits([]);
  // TODO convert event to a holder/context during search result refactoring
  TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onSetAudience, {
    audience: [],
  });
}
